import { Twelve24TCTool } from "features/WorklistTools/1224TC/state";
import { ExternalThawTool } from "features/WorklistTools/ExternalThaw/state";
import { NucleofectionTool } from "features/WorklistTools/Nucleofection/state";
import { PoolingNormalizationTool } from "features/WorklistTools/PoolingNormalization/state";
import { ThawTool } from "features/WorklistTools/ThawWorklistTool/state";
import { combineReducers } from "redux";

const JoinedReducer = combineReducers({
  ThawTool,
  PoolingNormalizationTool,
  Twelve24TCTool,
  ExternalThawTool,
  NucleofectionTool,
});

export default JoinedReducer;
